import * as Yup from "yup";

const lotValidation = Yup.lazy((lot) =>
  Yup.object({
    quantity:
      lot.quantity === ""
        ? Yup.mixed()
        : Yup.number().min(0).max(lot.quantityAvailable),
  }),
);

const skuValidation = Yup.lazy((lots = {}) => {
  return Yup.object(
    Object.keys(lots).reduce(
      (acc, lotId) => ({
        ...acc,
        [lotId]: lotValidation,
      }),
      {},
    ),
  );
});

const skusValidation = Yup.lazy((skus = {}) => {
  return Yup.object(
    Object.keys(skus).reduce(
      (acc, skuId) => ({
        ...acc,
        [skuId]: skuValidation,
      }),
      {},
    ),
  );
});

export const validationSchema = Yup.object({
  skus: skusValidation,
  notes: Yup.string(),
});
